module.exports = __webpack_public_path__ + "static/media/1021527.a28738ad.jpg";